export default "<div>\n  <alert [type]=\"type\" >{{ message }}</alert>\n</div>"